import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { MainHome } from "../components/Home/MainHome";
import LoaderComponent from "../components/Loader";
import StorefrontHead from "../components/StorefrontHead";
import { useStoreContext } from "../contexts/StoreDataContext";
import styles from "../styles/Home.module.css";
import { trackEvent } from "../utils/analytics";
import { EVENTS } from "../utils/analyticsConfig";
import NotFound from "./404";
import Error500Page from "./500";

export default function Home() {
  const context = useStoreContext();
  const router = useRouter();
  const store = context?.storeData;
  const theme = context?.themeData;
  const error = context?.error;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (store !== null) {
      setLoading(false);
    }
  }, [store]);

  useEffect(() => {
    if (store && store.homeLayout !== "featured") {
      router.replace("/collections/all");
    }
  }, [store, router]);

  // Top of the buyer funnel. Keyed on username (no Mongo id on session).
  // Follow-up: immutable analyticsKey on Store → session.
  const storeKey = store?.username;

  useEffect(() => {
    if (!storeKey) return;

    trackEvent(EVENTS.STORE_VIEWED, {
      store_has_home_page: store?.homeLayout === "featured",
      store_product_count: Array.isArray(store?.products) ? store.products.length : undefined,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeKey]);

  if (error && error.code === 500) return <Error500Page />;
  if (error && error === 404) return <NotFound />;
  if (!store || loading) return <LoaderComponent />;
  if (store.homeLayout !== "featured") return <LoaderComponent />;

  return (
    <div className={styles.container}>
      <StorefrontHead store={store} />
      <MainHome store={store} theme={theme} />
    </div>
  );
}
